module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("url querystring")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { querystring } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\nquerystring.parse("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'a=b&c=d'")]), _vm._v(") "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// {a:'b',c:'d'}, 默认参数为 location.search")]), _vm._v("\n\nquerystring.stringify({"), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("a")]), _vm._v(":"), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'b'")]), _vm._v(","), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("c")]), _vm._v(":"), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'d'")]), _vm._v("}) "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 'a=b&c=d'，注意不支持复杂嵌套的结构")]), _vm._v("\n")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-54de7cc2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-54de7cc2"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/querystring-182.vue
// module id = 2249
// module chunks = 409